import { ErrorType } from '../types/index.js';
import { ConcreteException } from '../base.js';
export class CosmosWalletException extends ConcreteException {
    static errorClass = 'CosmosWalletException';
    constructor(error, context) {
        super(error, context);
        this.type = ErrorType.WalletError;
    }
    parse() {
        this.setName(CosmosWalletException.errorClass);
    }
}
